import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { authScopes, protectedResources } from "../../authConfig";
import { callApi } from "../../helpers/call_api";
import { getIdToken } from "../../helpers/msal_auth";
import { UserPermissionData } from "../../models/UserPermissionData";
import { RootState } from "../store";
import { InteractionRequiredAuthError } from "@azure/msal-common";
import { PERMISSIONS } from "../../constant";

export interface DataState {
  data: UserPermissionData | null;
  isLoading: boolean;
}

const initialState: DataState = {
  data: null,
  isLoading: false,
};


export const getUserPermissionAsync = createAsyncThunk(
  "userPermission/get",
  async (_, { rejectWithValue }) => {
    try {
      let idToken = await getIdToken(authScopes);
      let data = await callApi(
        idToken,
        protectedResources.supportApi + "/admin/userPermissions",
        "GET"
      );
      return data;
    } catch (e) {
      var error = e;
      if (e instanceof InteractionRequiredAuthError) {
        error = new Error(
          JSON.stringify({
            status: 403,
            message: "InteractionRequiredAuthError",
          })
        );
      }
      try {
        _ = JSON.parse(error.message);
      } catch (objError) {
        if (objError instanceof SyntaxError) {
          error = new Error(
            JSON.stringify({
              status: 500,
              message: error.message,
            })
          );
        }
      }
      return rejectWithValue(error);
    }
  }
);

export const UserPermissionDataSlice = createSlice({
  name: "userPermissionData",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getUserPermissionAsync.fulfilled, (state, action) => {
      state.data = {
        users: action.payload?.users,
        roles: action.payload?.roles,
        permissions: {
          "ticket": PERMISSIONS.ticket,
          "report": action.payload?.permissions.report,
          "admin": PERMISSIONS.admin
        }
      };
      state.isLoading = false;
    });
    builder.addCase(getUserPermissionAsync.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getUserPermissionAsync.rejected, (state) => {
      state.isLoading = false;
    });
  },
});

export const userPermissionDataFromApi = (state: RootState) => state.userPermissionData.data;

export const isUserPermissionDataLoading = (state: RootState) => state.userPermissionData.isLoading;

export default UserPermissionDataSlice.reducer;
